import React, { useEffect, useState, useContext, useRef } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@mui/material/Tooltip";
import { confirmAlert } from "react-confirm-alert";
import toast from "react-hot-toast";

//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

//Context import
import AuthContext from "../../../../components/shared/Context";
import AllocateTCInventoryLocalModal from "./AllocateTCInventoryLocalModal";
import ExcelDownloader from "./ExcelDownloader"; // Import the ExcelDownloader component

const ProductWiseTCInventoryChild = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openAllocateModal, setOpenAllocateModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const searchRef = useRef();
  const { loggedInUserDetails } = useContext(AuthContext);
  //Error Logging Service
  const { errorLogApi, expiryFormatter } = useAtom(gbState);
  const [filterType, setFilterType] = useState("all");

  const getDataFromServer = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data.product_stock;
        // console.log(oldData);
        const updatedData = oldData.map((data) => {
          //   console.log(data.purchase_inventory.product_id.products);
          return {
            ...data,
            id: data?._id,
            stock_type: data?.product_stock?.stock_type, //newly added
            stock_transfer: data?.product_stock?.stock_transfer,
            product_name:
              data?.product_stock?.product_id?.products?.product_name,
            category:
              data?.product_stock?.product_id?.products?.category_id?.category,
            item_code: data?.product_stock?.item_code,
            measuring_unit:
              data?.product_stock?.product_id?.products?.measuring_unit,
            company_name:
              data?.product_stock?.product_id?.products?.company_name,
            product_expiry: data?.product_stock?.expiry_date,
            tc_name: data?.product_stock?.tc_id?.tcenters?.name_tc,
            state: data?.product_stock?.tc_id?.tcenters?.state,
            quantity:
              data?.product_stock?.quantity +
              " " +
              data?.product_stock?.product_id?.products?.storage_unit,
            updatedAt: data?.updatedAt,
          };
        });
        // console.log(updatedData);
        setData(updatedData);
        setUnfilteredData(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  useEffect(() => {
    getDataFromServer();
    // getProducts();
  }, []);

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "auto",
    },
  }));

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  const dateFormatter = (date) => {
    const date_conv = new Date(date);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date_conv.getMonth()];
    const year = date_conv.getFullYear();
    return `${month} ${year}`;
  };

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    const daysLeft = calculateDaysLeft(params.row.product_expiry);
    return (
      <Tooltip title={params.row.product_name}>
        <div
          className={classes.multiLineCell}
          style={{ color: daysLeft < 0 ? "red" : "inherit" }}
        >
          <span
            id="content1"
            style={{ display: "flex", alignItems: "center" }}
            className="text-bold"
          >
            {params.row.product_name}
          </span>
          <span id="content2">
            <small className="small-font-size">
              Expiry:{" "}
              {daysLeft !== null ? (
                <span>
                  {`${dateFormatter(
                    params.row.product_expiry
                  )} (${daysLeft}) days`}
                </span>
              ) : (
                <p>Loading...</p>
              )}
            </small>
          </span>
        </div>
      </Tooltip>
    );
  };

  const columns = [
    {
      field: "Info",
      headerName: (
        <i
          className="mdi mdi-information"
          style={{ fontSize: "20px", color: "grey" }}
        ></i>
      ),
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 40,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="editiConContainer">
            <Tooltip title="View Product">
              <a onClick={() => viewRecord(params.row)}>
                <i
                  className="mdi mdi-information"
                  style={{ fontSize: "20px", color: "green" }}
                ></i>
              </a>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "product_name",
      headerName: "Product",
      width: 240,
      renderCell: MultiLineCellRenderer,
    },
    {
      field: "category",
      headerName: "Category",
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      width: 120,
    },
    {
      field: "item_code",
      headerName: "Product Code",
      width: 120,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "quantity",
      headerName: "Bal. Quantity",
      width: 140,
      filterable: false,
      disableColumnMenu: true,
      align: "left",
    },
    {
      field: "stock_type",
      headerName: "Stock Type",
      width: 140,
      filterable: false,
      disableColumnMenu: true,
      align: "left",
      renderCell: (params) =>
        params?.row?.stock_type ? (
          <Badge
            bg={badgeStatus[1].badge}
            style={{ width: "100%", display: "block", fontSize: "0.6rem" }}
          >
            NODAL PURCHASE
          </Badge>
        ) : (
          <Badge
            bg={badgeStatus[3].badge}
            style={{ width: "100%", display: "block", fontSize: "0.6rem" }}
          >
            STATE PURCHASE
          </Badge>
        ),
    },
    {
      field: "stock_transfer",
      headerName: "Transfer Type",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "left",
      renderCell: (params) =>
        params?.row?.stock_transfer ? (
          <Badge
            bg={badgeStatus[4].badge}
            style={{ width: "100%", display: "block", fontSize: "0.6rem" }}
          >
            TRANSFER
          </Badge>
        ) : (
          <Badge
            bg={badgeStatus[6].badge}
            style={{ width: "100%", display: "block", fontSize: "0.6rem" }}
          >
            DIRECT
          </Badge>
        ),
    },
    {
      field: "tc_name",
      headerName: "TC ",
      width: 140,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "state",
      headerName: "State",
      width: 155,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "Action",
      headerName: "Action",
      width: 130,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <button
          className={`btn btn-sm text-white ${
            calculateDaysLeft(params.row.product_expiry) <= 0 ||
            parseInt(params.row.quantity) <= 0
              ? "btn-secondary"
              : "btn-primary"
          }`}
          onClick={() => {
            setCurrentRecord(params.row);
            setOpenAllocateModal(true);
          }}
          disabled={
            Boolean(loggedInUserDetails.allocate_to_tcs)
              ? calculateDaysLeft(params.row.product_expiry) <= 0 ||
                parseInt(params.row.quantity) <= 0
              : true
          }
        >
          Allocate to TC
        </button>
      ),
      align: "center",
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };

  const handleSearch = (e) => {
    if (e) {
      const filteredData = unfilteredData.filter((item) => {
        return (
          item?.product_code?.toLowerCase().includes(e?.toLowerCase()) ||
          item?.product_name?.toLowerCase().includes(e?.toLowerCase()) ||
          item?.item_code?.toLowerCase().includes(e?.toLowerCase()) ||
          item?.company_name?.toLowerCase().includes(e?.toLowerCase()) ||
          item?.state?.toLowerCase().includes(e?.toLowerCase()) ||
          item?.quantity?.toLowerCase().includes(e?.toLowerCase())
        );
      });

      // Apply the current expiry filter to the search results
      if (filterType === "expired") {
        setData(
          filteredData.filter(
            (item) => calculateDaysLeft(item.product_expiry) <= 0
          )
        );
      } else if (filterType === "useable") {
        setData(
          filteredData.filter(
            (item) =>
              calculateDaysLeft(item.product_expiry) > 0 &&
              parseInt(item.quantity) > 0
          )
        );
      } else {
        setData(filteredData);
      }
    } else {
      // When clearing search, respect the current filter
      handleFilterChange(filterType);
    }
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    getDataFromServer();
  };

  const badgeStatus = {
    0: { badge: "warning", label: "PENDING" },
    1: { badge: "primary", label: "PROCESSING" },
    2: { badge: "danger", label: "REJECTED" },
    3: { badge: "success", label: "COMPLETED" },
    4: { badge: "info", label: "ON HOLD" },
    5: { badge: "secondary", label: "CANCELLED" },
    6: { badge: "dark", label: "EXPIRED" },
    7: { badge: "light", label: "DRAFT" },
  };

  const handleFilterChange = (type) => {
    setFilterType(type);

    if (type === "all") {
      setData(unfilteredData);
    } else if (type === "expired") {
      setData(
        unfilteredData.filter(
          (item) => calculateDaysLeft(item.product_expiry) <= 0
        )
      );
    } else if (type === "useable") {
      setData(
        unfilteredData.filter(
          (item) =>
            calculateDaysLeft(item.product_expiry) > 0 &&
            parseInt(item.quantity) > 0
        )
      );
    }
  };

  //Bulk Delete function
  const handleSelectionChange = (selectionModel) => {
    // `selectionModel` will be an array of IDs of selected rows
    setSelectedIds(selectionModel);
  };

  const deleteMultipleRecords = () => {
    let inputCode = "";
    if (!selectedIds?.length) return toast.error("Please select Record(s)");

    confirmAlert({
      title: "",
      message: "Are you sure to delete record(s) ?",
      childrenElement: () => (
        <div>
          {/* Use the key here */}
          <input
            type="text"
            placeholder="Type Code..."
            className="mt-2"
            onChange={(e) => (inputCode = e.target.value)} // Direct assignment
          />
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecordInBulk(inputCode),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecordInBulk = (inputCode) => {
    if (!inputCode) return toast.error("Please enter a valid code!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/tcpwstock/delete/bulk`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ids: selectedIds, secret_code: inputCode },
    };
    if (selectedIds.length > 0) {
      axios(config)
        .then(function (response) {
          getDataFromServer();
          toast.success("Stock Deleted Successfully.");
        })
        .catch(function (error) {
          errorLogApi(error, "PWStockDeleteMany", "/delete/bulk");
          toast.error(JSON.stringify(error.response.data.message));
        });
    }
  };

  return (
    <div>
      <span className="card-title">
        <h3>ProductWise TC Stocks (Current Status)</h3>
      </span>
      <div className="text-end">
        <ExcelDownloader
          data={data}
          filename={`productwise_status_${new Date()
            .toISOString()
            .replace(/[-:.]/g, "")}.xlsx`}
          excludedFields={[
            "_id",
            "id",
            "s_register",
            "__v",
            "patient_record",
            "visit_record",
            "product_stock",
          ]}
        />
        {loggedInUserDetails?.force_delete === true && (
          <button
            className="btn btn-danger ms-2"
            onClick={deleteMultipleRecords}
          >
            <i className="mdi mdi-delete"></i>
          </button>
        )}
      </div>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / State / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <div className="mb-3">
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="filterOptions"
            id="all"
            checked={filterType === "all"}
            onChange={() => handleFilterChange("all")}
          />
          <label className="form-check-label" htmlFor="all">
            All
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="filterOptions"
            id="expired"
            checked={filterType === "expired"}
            onChange={() => handleFilterChange("expired")}
          />
          <label className="form-check-label" htmlFor="expired">
            Expired
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="filterOptions"
            id="useable"
            checked={filterType === "useable"}
            onChange={() => handleFilterChange("useable")}
          />
          <label className="form-check-label" htmlFor="useable">
            Useable
          </label>
        </div>
      </div>
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        displayTitle="Current Stocks"
        checkboxSelection
        style={{ height: "60vh" }}
        onSelectionModelChange={handleSelectionChange}
      />
      {/* {JSON.stringify(loggedInUserDetails)} */}
      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Stocks Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent
            currentRecord={currentRecord}
            dateFormatter={dateFormatter}
          />
        </Modal.Body>
      </Modal>

      {/* Modal Drug Allocate Popup */}
      <Modal show={openAllocateModal} size="lg" centered>
        <Modal.Header closeButton onClick={() => setOpenAllocateModal(false)}>
          <Modal.Title>Local Allocation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AllocateTCInventoryLocalModal
            currentRecord={currentRecord}
            refreshStock={getDataFromServer}
          />
        </Modal.Body>
      </Modal>
      {/* {JSON.stringify(currentRecord)} */}
    </div>
  );
};

const ModalContent = ({ currentRecord, dateFormatter }) => {
  return (
    <div className="container-fluid">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th scope="row">Product Name</th>
            <td>{currentRecord?.product_name}</td>
          </tr>
          <tr>
            <th scope="row">Measuring Units</th>
            <td>{currentRecord?.measuring_unit}</td>
          </tr>
          <tr>
            <th scope="row">Category</th>
            <td>{currentRecord?.category}</td>
          </tr>
          <tr>
            <th scope="row">Quantity</th>
            <td>{currentRecord?.quantity}</td>
          </tr>
          <tr>
            <th scope="row">Expiry</th>
            <td>{dateFormatter(currentRecord?.product_expiry)}</td>
          </tr>
          <tr>
            <th scope="row">Company Name</th>
            <td>{currentRecord?.company_name}</td>
          </tr>
          <tr>
            <th scope="row">State</th>
            <td>{currentRecord?.state}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProductWiseTCInventoryChild;
